export const SAVE_DISCOUNTS = 'SAVE_DISCOUNTS';

export const saveDiscounts = (discounts) => ({
  type: SAVE_DISCOUNTS,
  discounts: discounts,
});
